import { COLORS } from '@/utils/static/colors';
import { UserOutlined, TeamOutlined } from '@ant-design/icons';

export const INVESTOR_TYPES_CONFIG = {
  PERSONAL: {
    title: 'Natural person',
    color: COLORS.iconColor,
    icon: UserOutlined
  },
  COMPANY: {
    title: 'Legal entity',
    color: COLORS.iconColor,
    icon: TeamOutlined
  }
};

export const INVESTOR_STATUS_TABS = [
  'For approval',
  'Active Investors',
  'All Investors',
  'Blocked'
];
export const INVESTOR_STATUS_DESCRIPTION = [
  'Individual Clients Under Review',
  'Active Individual Clients',
  'All Individual Clients',
  'Blocked Individual Clients'
];
export const LEGAL_STATUS_TABS = ['Under Review', 'Active', 'All', 'Blocked'];
export const LEGAL_STATUS_DESCRIPTION = [
  'Legal Entities Under Review',
  'Active Legal Entities',
  'All Legal Entities',
  'Blocked Legal Entities'
];
export const TABS_LABELS = ['questionnaires', 'documents', 'structure', 'products'];

export const STATUS_TAB_VALUE = ['ACTIVE', 'ACTIVE', null, 'NOT_ACTIVE'];
export const IS_IN_REVIEW_TAB_VALUE = [true, null, null, null];

export const DISPLAY_INVESTOR_ACCOUNT_STATUS = {
  ACTIVE: 'Active',
  NOT_ACTIVE: 'Blocked'
};
